import React, { useState } from "react";
import { Fragment } from "react";
import { H4, H3 } from '../../../AbstractElements'
import { Card, CardBody, Row, Col, Table } from "reactstrap";
import { baselineEmission, projectEmission } from "./CalculationHelper";
import EmissionModal from "./EmissionModal";

const BiocharCalculation = () => {
    return (
        <Fragment>
            <Row>
                <Col lg='8'>
                    <Card>
                        <CardBody>
                            <div>
                                <div>
                                    <H3 attrH3={{ className: 'f-w-600' }}>ERy(Carbon credits) = ER<sub>SS,y</sub> + ER<sub>PS,y</sub> - PE<sub>AS,y</sub> - LEy</H3>
                                </div>
                                <div className="mtop-1">
                                    <H4 attrH4={{ className: 'f-w-600' }}>Description</H4>
                                    <ul>
                                        <li>
                                            <p>ER<sub>SS,y</sub> = GHG emission reductions at sourcing stage in year(y) (tCO2e)</p>
                                        </li>
                                        <li>
                                            <p>ER<sub>PS,y</sub> = GHG emission removals at production stage in year(y) (tCO2e)</p>
                                        </li>
                                        <li>
                                            <p>PE<sub>AS,y</sub> = GHG emission at application stage in year(y) (tCO2e)</p>
                                        </li>
                                        <li>
                                            <p>PEy = Total leakage emissions in year(y) (tCO2e)</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg="8">
                    <Card>
                        <CardBody>
                            <p>Example</p>
                            <Table bordered striped>
                                <thead>
                                    <tr>
                                        <th className="d-flex justify-center">Year</th>
                                        <th>
                                            <div className="d-flex justify-center">
                                                GHG reduction source
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex justify-center">
                                                GHG reduction production
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex justify-center">
                                                GHG reduction application
                                            </div>
                                        </th>
                                        <th className="d-flex justify-center">Carbon Credits</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2024</td>
                                        <td className="text-right">0</td>
                                        <td className="text-right">452480.00</td>
                                        <td className="text-right">226240.00</td>
                                        <td className="text-right">678720.00</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td className="text-right">0</td>
                                        <td className="text-right">452480.00</td>
                                        <td className="text-right">226240.00</td>
                                        <td className="text-right">678720.00</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    )
}

export default BiocharCalculation;